export default class Day {
  constructor (data) {
    this.id = data.id
    this.groupId = data.groupId
    this.name = data.name
    this.date = data.date
    this.deferred = data.deferred
  }
}
